import { AlertRecord, AlertRecordWithDate } from 'lib/alert/models';

/**
 * This function return the records sorted by date by descending order.
 * It will convert the date string to an actual date object and also return
 * date since when the alert is in its last state.
 *
 * @param {AlertRecord[]} records - The records to sort and get the info from.
 * @return {Object} and object with the following keys:
 *   - `records`: The records sorted by date
 *   - `since`: The date since when the alert is in state `lastState`.
 */
export const getSortedAlertAndStateInfo = (
    records: AlertRecord[],
): { records: AlertRecordWithDate[]; since: Date } => {
    const recordsWithDate: AlertRecordWithDate[] = records.map((r) => ({
        ...r,
        date: new Date(r.date),
    }));
    recordsWithDate.sort((a, b) => b.date.getTime() - a.date.getTime());

    const lastState = recordsWithDate[0].status;
    let stateSince = recordsWithDate[0].date;
    for (let i = 1; i < recordsWithDate.length; i += 1) {
        if (recordsWithDate[i].status === lastState) {
            stateSince = recordsWithDate[i].date;
        } else {
            break;
        }
    }

    return {
        records: recordsWithDate,
        since: stateSince,
    };
};
